import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Loader } from '@progress/kendo-react-indicators';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label } from '@progress/kendo-react-labels';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { useState } from 'react';
import { fetchApi } from '../../services/api';
import { JsonResponse } from 'TypeGen/json-response';

type Props = {
  SalespersonID: string;
  CloseDialog: () => void;
  Refresh: () => void;
}

const RetirePopup = (props: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [date, setDate] = useState<Date | null>(new Date());

  const retire = () => {
    setLoading(true);
    const data = { RetiredDate: date };
    fetchApi(`/api/Customer/RetireSalesperson/${props.SalespersonID}`, data, 'POST')
      .then((response: JsonResponse) => {
        setLoading(false);
        if (response.Success) {
          props.CloseDialog();
          props.Refresh();
        } else {
          alert(response.ErrorMessage);
        }
      })
      .catch(() => {
        setLoading(false);
        alert('Unable to retire');
      });
  };

  return (
    <div className="container-fluid">
      <Dialog title="Retire Salesperson" onClose={props.CloseDialog} className="dialog-w525" height={260}>
        {loading && (
          <div className="k-pos-absolute k-top-center mt-5">
            <Loader type="converging-spinner" />
          </div>
        )}
        <div className="row">
          <div className="col">
            <form className="k-form k-form-md p-0">
              <FieldWrapper>
                <Label>Retired Date</Label>
                <DatePicker
                  format="MM/dd/yyyy"
                  min={new Date(1753, 1, 1)}
                  max={new Date()}
                  formatPlaceholder="formatPattern"
                  value={date}
                  onChange={(e) => setDate(e.value)}
                />
              </FieldWrapper>
            </form>
          </div>
        </div>
        <br />
        <p>Are you sure you want to retire this salesperson?</p>
        <DialogActionsBar>
          <Button onClick={props.CloseDialog}>Cancel</Button>
          <Button themeColor="primary" onClick={retire}>Retire Salesperson</Button>
        </DialogActionsBar>
      </Dialog>
    </div>
  );
};

export default RetirePopup;